/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { usePreparedProducts } from "./usePreparedProducts";
import { useProductsSearchSort } from "./useProductsSearchSort";

export const useProductsWithSearchSort = ({ categoryId = null, forSale = false } = {}) => {
  const { searchValue, debouncedSearch, sortBy, orderField, orderDirection, setSearchValue, setSortBy } = useProductsSearchSort();
  const result = usePreparedProducts({ search: debouncedSearch, orderField, orderDirection, categoryId, forSale });

  const searchSortProps = {
    searchValue, debouncedSearch, sortBy,
    onSearchChange: setSearchValue,
    onSortChange: setSortBy,
    hasNextPage: result.hasNextPage,
    isFetchingNextPage: result.isFetchingNextPage,
    onLoadMore: result.fetchNextPage,
    resetKey: `${debouncedSearch}-${sortBy}-${categoryId}`,
  };

  return { ...result, searchSortProps };
};